<script>
import IndustryOperationChart from './leftTop.vue'

export default {
  name: 'IndustryOperationDetails',
  components: { IndustryOperationChart },
  props: {
    visible: { type: Boolean, default: false },
    dataset: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' }
  },
  methods: {
    resizeCharts() {
      const charts = this.$refs.charts || []
      charts.forEach(chart => chart.resizeChart())
    }
  }
}
</script>

<template>
  <el-dialog
    title="产业运行分析"
    custom-class="industry-operation-dialog"
    :visible="visible"
    width="92%"
    top="4vh"
    append-to-body
    :close-on-click-modal="false"
    @close="$emit('close')"
     @opened="resizeCharts"
  >
    <div v-if="visible" class="operation-details-content">
      <div v-if="loading" class="operation-state" role="status">正在加载产业运行分析…</div>
      <div v-else-if="error" class="operation-state" role="alert">
        <p>{{ error }}</p>
        <button type="button" class="operation-retry" @click="$emit('retry')">重新加载</button>
      </div>
      <template v-else-if="dataset && dataset.scenarios.length">
        <div class="operation-summary">
          <div class="operation-period">{{ dataset.year }} 年 {{ dataset.startMonth }}—{{ dataset.endMonth }} 月</div>
          <div class="operation-updated">更新时间：{{ dataset.updatedAt || '暂无数据' }}</div>
        </div>
        <p v-if="dataset.sourceNote" class="operation-source">{{ dataset.sourceNote }}</p>
        <div class="operation-detail-grid">
          <section v-for="scenario in dataset.scenarios" :key="scenario.code" class="operation-detail-card">
            <h3 class="operation-card-title">{{ scenario.name }}</h3>
            <IndustryOperationChart ref="charts" :chart-data="scenario" class="operation-detail-chart" />
            <div v-if="scenario.report" class="operation-report">
              <h4 class="operation-report-title">数据分析</h4>
              <dl class="operation-report-list">
                <dt>总体结论</dt>
                <dd>{{ scenario.report.conclusion || '暂无分析' }}</dd>
                <dt>存在问题</dt>
                <dd>
                  <ul v-if="scenario.report.issues && scenario.report.issues.length" class="operation-report-items">
                    <li v-for="(issue, index) in scenario.report.issues" :key="index">{{ issue }}</li>
                  </ul>
                  <span v-else>暂无分析</span>
                </dd>
                <dt>发展建议</dt>
                <dd>
                  <ul v-if="scenario.report.suggestions && scenario.report.suggestions.length" class="operation-report-items">
                    <li v-for="(suggestion, index) in scenario.report.suggestions" :key="index">{{ suggestion }}</li>
                  </ul>
                  <span v-else>暂无分析</span>
                </dd>
              </dl>
            </div>
            <p v-else class="operation-source">暂无分析报告</p>
          </section>
        </div>
      </template>
      <div v-else class="operation-state" role="status">
        <p>暂无产业运行分析数据</p>
        <button type="button" class="operation-retry" @click="$emit('retry')">重新加载</button>
      </div>
    </div>
  </el-dialog>
</template>

<style>
/* append-to-body 的弹窗单独限定类名，不影响大屏已有弹窗。 */
.industry-operation-dialog.el-dialog {
  max-width: 1380PX;
  margin-bottom: 4vh;
  border: 1PX solid #2682C3;
  border-radius: 12PX;
  /* 旧页面全局 .el-dialog 使用 transparent !important，仅覆盖本弹窗。 */
  background-color: #072859 !important;
  box-shadow: 0 16PX 60PX rgba(0, 0, 0, .5);
}
.industry-operation-dialog .el-dialog__header {
  padding: 22PX 28PX 18PX;
  border-bottom: 1PX solid rgba(82, 177, 245, .25);
}
.industry-operation-dialog .el-dialog__title { color: #E7FCFF; font-size: 22PX; }
.industry-operation-dialog .el-dialog__headerbtn { top: 22PX !important; right: 24PX !important; font-size: 24PX; }
.industry-operation-dialog .el-dialog__headerbtn .el-dialog__close { color: #BDEAFF; }
.industry-operation-dialog .el-dialog__body { padding: 0; color: #DAECFC; }
.industry-operation-dialog .el-dialog__headerbtn:focus-visible { outline: 2PX solid #72DFFF; outline-offset: 3PX; }
</style>

<style scoped>
.operation-details-content { max-height: 78vh; overflow-y: auto; padding: 22PX 28PX 28PX; }
.operation-summary { display: flex; justify-content: space-between; align-items: baseline; gap: 12PX; flex-wrap: wrap; }
.operation-period { color: #79DCFF; font-size: 18PX; font-weight: 600; }
.operation-updated { color: #A3BED8; font-size: 12PX; }
.operation-source { margin: 12PX 0 20PX; color: #A9C4DE; font-size: 13PX; line-height: 1.7; }
.operation-detail-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20PX; }
.operation-detail-card { min-width: 0; padding: 20PX; border: 1PX solid rgba(75, 166, 235, .3); border-radius: 8PX; background: rgba(10, 69, 121, .45); }
.operation-card-title { margin: 0 0 20PX; color: #D5F4FF; font-size: 18PX; }
.operation-detail-chart { height: 280PX; }
.operation-report { margin-top: 20PX; border-top: 1PX solid rgba(75, 166, 235, .25); }
.operation-report-title { margin: 16PX 0 10PX; color: #67D7FF; font-size: 15PX; }
.operation-report-list { margin: 0; font-size: 13PX; line-height: 1.8; }
.operation-report-list dt { margin-top: 12PX; color: #BDE7FF; font-weight: 600; }
.operation-report-list dd { margin: 4PX 0 0; color: #B5CBE1; white-space: pre-line; overflow-wrap: anywhere; }
.operation-report-items { margin: 0; padding-left: 18PX; }
.operation-report-items li + li { margin-top: 5PX; }
.operation-state { padding: 60PX 12PX; color: #B5CBE1; text-align: center; font-size: 15PX; }
.operation-retry { padding: 8PX 18PX; border: 1PX solid #38B6EB; border-radius: 4PX; color: #C2F1FF; background: #0B4677; font-size: 14PX; cursor: pointer; }
.operation-retry:focus-visible { outline: 2PX solid #72DFFF; outline-offset: 3PX; }
@media (max-width: 900px) {
  .operation-detail-grid { grid-template-columns: minmax(0, 1fr); }
  .operation-details-content { padding: 18PX 14PX; }
  .operation-detail-card { padding: 14PX; }
}
</style>
